export default __webpack_public_path__ + "static/media/9.14b30c24.jpg";